import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { CanDeactivate } from "@angular/router";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { DialogData } from "../dialog-common/dialog-common.model";
import { DialogConfirmDeleteComponent } from "../dialog-confirm-delete/dialog-confirm-delete.component";
import { CanDeactivateListener } from "./can-deactivate-listener";

@Injectable()
export class CanDeactivateGuard
  implements CanDeactivate<CanDeactivateListener>
{
  constructor(private matDialog: MatDialog) {}

  canDeactivate(
    component: CanDeactivateListener
  ): boolean | Observable<boolean> {
    if (!component.canDeactivate()) {
      const dialogRef = this.matDialog.open(DialogConfirmDeleteComponent, {
        data: new DialogData(
          "Just Checking",
          "You have unsaved changes. If you select continue, your changes will be lost."
        ),
        panelClass: "base-modal-panel",
        backdropClass: "base-modal-backdrop",
      });

      // Router's canDeactivate guard resolution only treats `true`, `false`, or a
      // UrlTree as valid — any other value (afterClosed() emits `undefined` on
      // Cancel) is silently ignored and the router falls through to `true`,
      // letting navigation through regardless of what the user chose. Coerce to
      // a real boolean so Cancel actually resolves to `false`.
      return dialogRef.afterClosed().pipe(map((result) => !!result));
    }
    return true;
  }
}
